import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { SidebarService } from '@core/services/presenters/sidebar.service';
import { IconWrapperComponent } from '@shared/design/molecules/icon-wrapper/icon-wrapper.component';

@Component({
  selector: 'app-layout-sidebar',
  imports: [CommonModule, IconWrapperComponent],
  templateUrl: './layout-sidebar.component.html',
  styleUrl: './layout-sidebar.component.scss',
})
export class LayoutSidebarComponent {
  constructor(readonly sidebarService: SidebarService) {}

  toggleSidebar() {
    this.sidebarService.toggleCollapsed();
  }

  onMouseEnter() {
    this.sidebarService.expandOnHover();
  }

  onMouseLeave() {
    this.sidebarService.collapseOnHoverEnd();
  }
}
